import React, {Component} from "react";
import {Badge, Button, Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from "reactstrap";
import {getData, postData} from "../../api/doLogin";
import {EventClient} from "../../util/eventClient";
import {hasPermission} from "../../api/permissionHelper";
import {RequiredPermissions} from "../../api/permissions";

export class SMSDropdown extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      dropdownOpen: false,
      data: [],
    };
    this.timer = null;
  }

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  componentDidMount() {
    if (hasPermission(RequiredPermissions.SMSRead)) {
      this.updateFeed();
    }
  }

  componentWillUnmount() {
    if (this.timer) clearTimeout(this.timer);
  }

  updateFeed() {
    getData(`sms/feed`, {})
      .then((data) => {
        // console.log(data);
        if (data.status === "Success") {
          if (this.state.data.filter((sms) => sms.type === 'new').length < data.data.inbound.filter((sms) => sms.type === 'new').length) {
            EventClient.emit("TOAST_INFO", "You have new SMS Messages");
          }
          this.setState({data: data.data.inbound || []});
        }
      })
      .catch((err) => {
        console.log(err);
      }).finally(() => {
      this.timer = setTimeout(() => {
        this.updateFeed();
      }, 120000)
    });
  }

  markRead(id) {
    postData(`sms/${id}`, {type: 'read'})
      .then((data) => {
        // console.log(data);
        if (data.status === "Success") {
          this.setState({
            data: this.state.data.map((sms) => {
              if (sms.id === id) {
                return {...sms, type: 'read'}
              } else {
                return sms
              }
            })
          });
        }
      })
      .catch((err) => {
        console.log(err);
      })
  }

  delete(id) {
    postData(`sms/${id}`, {visible: 0})
      .then((data) => {
        // console.log(data);
        if (data.status === "Success") {
          this.setState({
            data: this.state.data.filter((sms) => sms.id !== id)
          });
        }
      })
      .catch((err) => {
        console.log(err);
      })
  }

  render() {
    if (!hasPermission(RequiredPermissions.SMSRead)) return null;
    const itemsCount = this.state.data.filter((sms) => sms.type === 'new').length;
    const existingCount = this.state.data.filter((sms) => sms.type !== 'new').length;
    // className="d-md-down-none"
    return (
      <Dropdown nav isOpen={this.state.dropdownOpen} toggle={this.toggle}>
        <DropdownToggle nav>
          <i className="icon-screen-smartphone" style={{fontSize: 20}}></i>
          {itemsCount > 0 && (
            <Badge pill color="info">{itemsCount}</Badge>
          )}
        </DropdownToggle>
        <DropdownMenu right style={{width: 500, maxHeight: 500, overflowY: "auto"}}>
          <DropdownItem header tag="div" toggle={false}><strong>You have {itemsCount + existingCount} messages
            ({itemsCount} new)</strong></DropdownItem>
          {this.state.data.map((sms) => {

            return <DropdownItem key={String(sms.id)} toggle={false} tag={"div"}>
              <div className="message">
                <div className="py-3 mr-3 float-left">
                  <div className="avatar">
                    {/*  <img src={'img/avatars/7.jpg'} className="img-avatar" alt="admin@bootstrapmaster.com"/>*/}
                    {sms.type === 'new' && <Badge className="avatar-status" color="info" title={"New"}></Badge>}
                  </div>
                </div>
                <div>
                  <small className="font-weight-bold">{sms.fname} {sms.lname} - {sms.from}</small>
                  <small className="text-muted float-right mt-1">{sms.added.split(".")[0].replace("T", " ")} PST</small>
                </div>
                {/*<div className="text-muted text-truncate">{sms.type === 'new' ? <Fragment><span*/}
                {/*  className="fa fa-exclamation text-danger"></span>&nbsp;*/}
                {/*  New </Fragment> : <Fragment>Existing</Fragment>}*/}
                {/*</div>*/}
                <div className="small text-muted" style={{
                  overflow: "unset",
                  textOverflow: "unset",
                  whiteSpace: "break-spaces"
                }}>{sms.msg}</div>
                <div style={{float: "right"}}>
                  <Button style={{height: 20, width: 40, padding: 0, margin: 0}}
                          onClick={(evt) => {
                            evt.preventDefault();
                            evt.stopPropagation();
                            this.markRead(sms.id);
                          }}>Read</Button>
                  {hasPermission(RequiredPermissions.SMSRemove) && (
                    <Button style={{height: 20, width: 50, padding: 0, margin: 0}}
                            onClick={(evt) => {
                              evt.preventDefault();
                              evt.stopPropagation();
                              this.delete(sms.id);
                            }}>Delete</Button>
                  )}
                  {sms.lmsID > 0 && (
                    <Button style={{height: 20, width: 35, padding: 0, margin: 0}}
                            onClick={(evt) => {
                              evt.preventDefault();
                              evt.stopPropagation();
                              this.toggle();
                              EventClient.emit("LMS_ENTRY_EDIT", sms.lmsID);
                            }}>LMS</Button>
                  )}
                </div>
                <p style={{clear: "right", margin: 0}}></p>
              </div>
            </DropdownItem>
          })}

          {/*<DropdownItem href="#">*/}
          {/*  <div className="message">*/}
          {/*    <div className="py-3 mr-3 float-left">*/}
          {/*      <div className="avatar">*/}
          {/*        <img src={'img/avatars/6.jpg'} className="img-avatar" alt="admin@bootstrapmaster.com"/>*/}
          {/*        <Badge className="avatar-status" color="warning"></Badge>*/}
          {/*      </div>*/}
          {/*    </div>*/}
          {/*    <div>*/}
          {/*      <small className="text-muted">Jane Doe</small>*/}
          {/*      <small className="text-muted float-right mt-1">5 minutes ago</small>*/}
          {/*    </div>*/}
          {/*    <div className="text-truncate font-weight-bold">Lorem ipsum dolor sit amet</div>*/}
          {/*    <div className="small text-muted text-truncate">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*</DropdownItem>*/}
          {/*<DropdownItem href="#">*/}
          {/*  <div className="message">*/}
          {/*    <div className="py-3 mr-3 float-left">*/}
          {/*      <div className="avatar">*/}
          {/*        <img src={'img/avatars/5.jpg'} className="img-avatar" alt="admin@bootstrapmaster.com"/>*/}
          {/*        <Badge className="avatar-status" color="danger"></Badge>*/}
          {/*      </div>*/}
          {/*    </div>*/}
          {/*    <div>*/}
          {/*      <small className="text-muted">Janet Doe</small>*/}
          {/*      <small className="text-muted float-right mt-1">1:52 PM</small>*/}
          {/*    </div>*/}
          {/*    <div className="text-truncate font-weight-bold">Lorem ipsum dolor sit amet</div>*/}
          {/*    <div className="small text-muted text-truncate">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*</DropdownItem>*/}
          {/*<DropdownItem href="#">*/}
          {/*  <div className="message">*/}
          {/*    <div className="py-3 mr-3 float-left">*/}
          {/*      <div className="avatar">*/}
          {/*        <img src={'img/avatars/4.jpg'} className="img-avatar" alt="admin@bootstrapmaster.com"/>*/}
          {/*        <Badge className="avatar-status" color="info"></Badge>*/}
          {/*      </div>*/}
          {/*    </div>*/}
          {/*    <div>*/}
          {/*      <small className="text-muted">Joe Doe</small>*/}
          {/*      <small className="text-muted float-right mt-1">4:03 AM</small>*/}
          {/*    </div>*/}
          {/*    <div className="text-truncate font-weight-bold">Lorem ipsum dolor sit amet</div>*/}
          {/*    <div className="small text-muted text-truncate">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*</DropdownItem>*/}
          {/*<DropdownItem href="#" className="text-center"><strong>View all messages</strong></DropdownItem>*/}
        </DropdownMenu>
      </Dropdown>
    );
  }

}


// WEBPACK FOOTER //
// ./src/components/Header/SMSDropdown.js